import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemMeshIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.27 5.02L13.38 0.440002C12.53 -0.0599976 11.47 -0.0599976 10.62 0.440002L2.72999 5.02C1.88999 5.51 1.35999 6.42 1.35999 7.4V16.6C1.35999 17.58 1.87999 18.49 2.72999 18.98L10.62 23.57C11.47 24.07 12.53 24.07 13.38 23.57L21.27 18.98C22.11 18.49 22.64 17.58 22.64 16.6V7.4C22.64 6.42 22.12 5.51 21.27 5.02ZM21.14 16.6C21.14 17.04 20.9 17.46 20.52 17.68L12.63 22.27C12.24 22.49 11.76 22.49 11.37 22.27L3.47999 17.68C3.09999 17.46 2.85999 17.04 2.85999 16.6V7.4C2.85999 6.96 3.09999 6.54 3.47999 6.32L11.37 1.73C11.76 1.51 12.24 1.51 12.63 1.73L20.52 6.32C20.9 6.54 21.14 6.96 21.14 7.4V16.6Z"
        fill={color}
      />
      <path
        d="M18.37 14.96L12.62 11.64V5C12.62 4.65 12.34 4.38 12 4.38C11.66 4.38 11.38 4.66 11.38 5V11.64L5.62999 14.96C5.32999 15.13 5.22999 15.51 5.39999 15.81C5.56999 16.11 5.95999 16.21 6.24999 16.04L12 12.72L17.75 16.04C18.04 16.21 18.43 16.11 18.6 15.81C18.77 15.51 18.67 15.13 18.37 14.96Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemMeshIcon.displayName = 'ItemMeshIcon';
